import { render, staticRenderFns } from "./FoodStreet.vue?vue&type=template&id=41f87b89&scoped=true&"
import script from "./FoodStreet.vue?vue&type=script&lang=js&"
export * from "./FoodStreet.vue?vue&type=script&lang=js&"
import style0 from "./FoodStreet.vue?vue&type=style&index=0&id=41f87b89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f87b89",
  null
  
)

export default component.exports